import { render, staticRenderFns } from "./CalendarEditForm.vue?vue&type=template&id=820b9128&scoped=true&"
import script from "./CalendarEditForm.vue?vue&type=script&lang=js&"
export * from "./CalendarEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEditForm.vue?vue&type=style&index=0&id=820b9128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820b9128",
  null
  
)

export default component.exports